export const profile = {
  'profile.businessTitle': 'Business Profile',
  'profile.businessSubtitle': 'Essential business information and metrics',
  'profile.clientProfileTitle': 'Client Profile',
  'profile.clientProfileSubtitle': 'Client details and contact information',
  'profile.assistantTitle': 'Business Assistant',
  'profile.assistantDesc': 'Get personalized recommendations',
  'profile.assistantPlaceholder': 'Ask me about business practices, funding opportunities, compliance requirements...',
  'profile.assistantResponse': 'Based on your business profile, I suggest exploring sustainable investment programs. There are several grants available for this type of upgrade that could cover up to 60% of costs. Would you like more information?',
  'profile.documentTitle': 'Documents',
  'profile.documentSubtitle': 'View and manage business documents',
  'profile.regulatoryOverview': 'Regulatory Overview',
  'profile.complianceStatus': 'Compliance Status',
  'profile.sustainabilityScore': 'Sustainability Score',
  'profile.certificationEligibility': 'Certification Eligibility',
  'profile.aiUpdates': 'AI Updates',
  'profile.aiUpdateInitial': 'How can I help improve my business sustainability score?',
  'profile.aiUpdateResponse': 'Based on your current metrics, focusing on operational efficiency and sustainable practices would have the biggest impact on your sustainability score.',
  'profile.regionOpportunityScore': 'Region Opportunity Score',
  'profile.fundingDensity': 'Funding Density',
  'profile.policyFriendliness': 'Policy Friendliness',
  'profile.recentApprovals': 'Recent Approvals',
  'profile.high': 'High',
  'profile.medium': 'Medium',
  'profile.veryHigh': 'Very High',
  'profile.low': 'Low',
  'profile.attachedSubsidies': 'Attached Subsidies',
  'profile.manuallyAttached': 'Manually Attached',
  'profile.noDocuments': 'No documents uploaded yet',
  'profile.readyForPrefill': 'Ready for prefill extraction',
  'profile.uploadDocument': 'Upload Document',
  'profile.documents': 'Documents',
  'profile.documentsUploaded': 'documents uploaded',
  'profile.extractedInformation': 'Extracted Information',

  // Profile Overview Enhanced
  'profile.editProfile': 'Edit Profile',
  'profile.seeSubsidies': 'See Subsidies',
  'profile.smartOverview': 'Smart Overview',
  'profile.fullProfile': 'Full Profile',

  // Company Identity Cockpit
  'profile.companyIdentity': 'Company Identity',
  'profile.legalName': 'Legal Name',
  'profile.legalForm': 'Legal Form',
  'profile.employees': 'Employees',
  'profile.siren': 'SIREN',
  'profile.sectorActivity': 'Sector & Activity',
  'profile.nafCode': 'NAF Code',
  'profile.activityDescription': 'Activity Description',
  'profile.leadership': 'Leadership',
  'profile.aiExtractedIntelligence': 'AI-Extracted Business Intelligence',
  'profile.businessActivities': 'Business Activities',
  'profile.innovationTechnology': 'Innovation & Technology',
  'profile.sustainabilityFocus': 'Sustainability Focus',
  'profile.exportMarkets': 'Export Markets',
  'profile.aiDiscovered': '✨ AI-discovered from website',
  'profile.automaticallyDiscovered': 'Automatically discovered from your company website',
  'profile.moreDirectors': 'more directors',

  // Company Details (Extended)
  'profile.noCompanyData': 'No company data available. Please complete your profile.',
  'profile.selectedSectors': 'Selected Sectors',
  'profile.director': 'Director',
  'profile.geographicPresence': 'Geographic Presence',
  'profile.headquarters': 'HQ',
  'profile.site': 'Site',
  'profile.moreLocations': 'more locations',
  'profile.sizeCategory': 'Size & Category',
  'profile.companyCategory': 'Company Category',
  'profile.employeeCount': 'Employee Count',
  'profile.employeesText': 'employees',
  'profile.companyAge': 'Company Age',
  'profile.yearsOld': 'years old',
  'profile.founded': 'Founded',
  'profile.establishments': 'Establishments',
  'profile.locationsText': 'location(s)',
  'profile.geographicLocation': 'Geographic Location',
  'profile.headquartersAddress': 'Headquarters Address',
  'profile.region': 'Region',
  'profile.codeLabel': 'Code:',
  'profile.department': 'Department',
  'profile.gpsCoordinates': 'GPS Coordinates',
  'profile.certifications': 'Certifications',
  'profile.certificationsInfo': 'These certifications may unlock additional subsidy opportunities',
  'profile.financialData': 'Financial Data',
  'profile.fiscalYear': 'Fiscal Year',
  'profile.revenue': 'Revenue (CA)',
  'profile.netProfit': 'Net Profit',
  'profile.dataEnrichmentInfo': 'Data Enrichment Info',
  'profile.source': 'Source:',
  'profile.dataCompleteness': 'Data Completeness:',
  'profile.lastUpdated': 'Last Updated:',
  'profile.subsidyMatchInfo': 'This information helps us find better subsidy matches for your company',

  // Key Info Categories
  'profile.category.funding': 'Funding Information',
  'profile.category.geographic': 'Geographic Scope',
  'profile.category.sector': 'Sectors & Industries',
  'profile.category.demographics': 'Target Demographics',
  'profile.category.timeline': 'Timing & Deadlines',

  // Profile Form Field Placeholders
  'profile.placeholders.enterProfileName': 'Enter profile name',
  'profile.placeholders.enterDescription': 'Enter description',
  'profile.placeholders.enterFullAddress': 'Enter full address',
  'profile.placeholders.enterPhoneNumber': 'Enter phone number',
  'profile.placeholders.enterEmail': 'Enter email address',
  'profile.placeholders.enterBusinessRegistration': 'Enter business registration number',
  'profile.placeholders.enterIndustry': 'Enter industry',
  'profile.placeholders.enterEmployees': 'e.g., 25-50',
  'profile.placeholders.enterRevenue': 'e.g., €2-5M',
  'profile.placeholders.searchCompany': 'Search by company name, SIREN (9 digits), or SIRET (14 digits)...',
  'profile.placeholders.enterCompanyWebsite': 'https://yourcompany.com',

  // Applicant Types
  'profile.applicantType.business': 'Business',
  'profile.applicantType.individual': 'Individual',

  // Edit Modals - Company Identity
  'profile.modal.editCompanyIdentity': 'Edit Company Identity',
  'profile.modal.editCompanyIdentityDesc': 'Update your company\'s basic information',
  'profile.modal.legalName': 'Legal Name',
  'profile.modal.legalForm': 'Legal Form',
  'profile.modal.siren': 'SIREN',
  'profile.modal.siret': 'SIRET',

  // Edit Modals - Company Size
  'profile.modal.editCompanySize': 'Edit Size & Category',
  'profile.modal.editCompanySizeDesc': 'Update your company\'s employee count',
  'profile.modal.numberOfEmployees': 'Number of Employees',

  // Edit Modals - Sector & Activity
  'profile.modal.editSectorActivity': 'Edit Sector & Activity',
  'profile.modal.editSectorActivityDesc': 'Update your business sector and activity information',
  'profile.modal.nafCode': 'NAF Code',
  'profile.modal.businessSectors': 'Business Sectors',
  'profile.modal.businessSectorsHelp': 'e.g., Innovation, Technology, Agriculture, Tourism',

  // Edit Modals - Leadership
  'profile.modal.editLeadership': 'Edit Leadership',
  'profile.modal.editLeadershipDesc': 'Manage your company\'s leadership team',
  'profile.modal.director': 'Director',
  'profile.modal.firstName': 'First Name(s)',
  'profile.modal.lastName': 'Last Name',
  'profile.modal.position': 'Position',
  'profile.modal.nationality': 'Nationality',
  'profile.modal.addDirector': 'Add Director',

  // Edit Modals - Geographic Presence
  'profile.modal.editGeographicPresence': 'Edit Geographic Presence',
  'profile.modal.editGeographicPresenceDesc': 'Manage your company\'s locations and establishments',
  'profile.modal.headquarters': 'Headquarters',
  'profile.modal.location': 'Location',
  'profile.modal.city': 'City',
  'profile.modal.postalCode': 'Postal Code',
  'profile.modal.address': 'Address',
  'profile.modal.addLocation': 'Add Location',

  // Edit Modals - AI Business Intelligence
  'profile.modal.editAIBusinessIntelligence': 'Edit AI Business Intelligence',
  'profile.modal.editAIBusinessIntelligenceDesc': 'Update your company\'s business intelligence data',
  'profile.modal.businessActivitiesLabel': 'Business Activities',
  'profile.modal.businessActivitiesHelp': 'One activity per line',
  'profile.modal.innovationTechnology': 'Innovation & Technology',
  'profile.modal.innovationTechnologyHelp': 'e.g., R&D programs, patents, digital transformation',
  'profile.modal.sustainabilityFocus': 'Sustainability Focus',
  'profile.modal.sustainabilityFocusHelp': 'e.g., Carbon neutral goals, renewable energy, circular economy',
  'profile.modal.exportMarkets': 'Export Markets',
  'profile.modal.exportMarketsHelp': 'e.g., Europe, North America, Asia-Pacific',

  // Edit Modals - Common Buttons
  'profile.modal.cancel': 'Cancel',
  'profile.modal.saving': 'Saving...',
  'profile.modal.saveChanges': 'Save Changes',

  // Employee Count Options
  'profile.employees.0': '0 employees',
  'profile.employees.1': '1 employee',
  'profile.employees.2-5': '2-5 employees',
  'profile.employees.6-10': '6-10 employees',
  'profile.employees.11-20': '11-20 employees',
  'profile.employees.21-50': '21-50 employees',
  'profile.employees.51-100': '51-100 employees',
  'profile.employees.101-250': '101-250 employees',
  'profile.employees.250+': '250+ employees',

  // Profile Edit Page
  'profile.edit.backToProfile': 'Back to Profile',
  'profile.edit.editProfile': 'Edit Profile',
  'profile.edit.updateProfileInfo': 'Update your profile information',
  'profile.edit.profileInformation': 'Profile Information',
  'profile.edit.deleteProfile': 'Delete Profile',
  'profile.edit.suspendProfile': 'Suspend Profile',
  'profile.edit.cancel': 'Cancel',
  'profile.edit.saveChanges': 'Save Changes',

  // Delete Confirmation
  'profile.delete.title': 'Delete Profile',
  'profile.delete.warning': 'This action cannot be undone. This will permanently delete your profile.',
  'profile.delete.confirmInstruction': 'To confirm, type',
  'profile.delete.confirmInstructionEnd': 'in the box below:',
  'profile.delete.confirmQuestion': 'Are you sure you want to delete "{name}"?',
  'profile.delete.deleting': 'Deleting...',
  'profile.delete.deleted': 'Profile deleted',
  'profile.delete.success': 'has been deleted successfully',
  'profile.delete.error': 'Failed to delete profile. Please try again.',

  // Suspend Confirmation
  'profile.suspend.title': 'Suspend Profile',
  'profile.suspend.warning': 'This profile will be hidden from your dashboard. You can restore it from Settings > Suspended Accounts.',
  'profile.suspend.confirmQuestion': 'Are you sure you want to suspend "{name}"?',
  'profile.suspend.suspending': 'Suspending...',
  'profile.suspend.suspended': 'Suspended',
  'profile.suspend.restore': 'Restore',
  'profile.suspend.deletePermantly': 'Delete Permanently',
  'profile.suspend.error': 'Failed to suspend profile. Please try again.',

  // Reactivate Profile
  'profile.reactivate.success': 'Profile reactivated',
  'profile.reactivate.description': 'has been reactivated and is now visible on your dashboard',
  'profile.reactivate.error': 'Failed to reactivate profile. Please try again.',

  // Company Search Section
  'profile.edit.companyInformation': 'Company Information',
  'profile.edit.useCompanySearch': 'Use Company Search',
  'profile.edit.enterManually': 'Enter Manually',
  'profile.edit.updateCompanyInfo': 'Update Company Information',

  // Website Intelligence
  'profile.edit.websiteIntelligence': 'Website Intelligence (Optional)',
  'profile.edit.websiteIntelligenceDesc': 'Add your company website to get AI-powered analysis for better subsidy matching.',
  'profile.edit.companyWebsite': 'Company Website',
  'profile.edit.allowAIAnalysis': 'Allow AI website analysis',
  'profile.edit.allowAIAnalysisDesc': 'We\'ll analyze your public website content to identify innovation, sustainability, and export capabilities for better subsidy matching.',
  'profile.edit.learnMore': 'Learn more',
  'profile.edit.analyzingWebsite': 'Analyzing Website...',
  'profile.edit.analyzeWebsite': 'Analyze Website with AI',
  'profile.edit.websiteAnalyzedSuccess': '✓ Website analyzed successfully',
  'profile.edit.aiGeneratedDescription': 'AI-Generated Company Description:',
  'profile.edit.useDescription': 'Use this description →',
  'profile.edit.businessActivitiesIdentified': 'business activities identified',
  'profile.edit.dataAnalyzedForMatching': 'Data analyzed to improve subsidy matching',

  // Form Fields
  'profile.edit.profileName': 'Profile Name',
  'profile.edit.description': 'Description',
  'profile.edit.address': 'Address',
  'profile.edit.phone': 'Phone',
  'profile.edit.email': 'Email',
  'profile.edit.businessRegistration': 'Business Registration',
  'profile.edit.industry': 'Industry',
  'profile.edit.numberOfEmployeesField': 'Number of Employees',
  'profile.edit.annualRevenue': 'Annual Revenue',

} as const;